import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MainPage = () => {
  const navigate = useNavigate();
  const [loggedIn, setLoggedIn] = useState(null);
  const [message, setMessage] = useState(''); // Deklariere 'message' und 'setMessage' mit useState
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  
  useEffect(() => {
    fetch(`${API_BASE_URL}/users/auth/status`, {
      method: 'get',
      credentials: 'include', // Wichtig, um Cookies mitzusenden
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setLoggedIn(data.loggedIn);
        if (data.loggedIn === false) {
          setMessage('Logge dich ein.'); // Set initial message if not logged in
        }
      })
      .catch(() => {
        setLoggedIn(false);
        setMessage('Logge dich ein.'); // Set initial message on error
      });
  }, []);

  if (loggedIn === null) {
    return <div className="container text-center py-5">Lade...</div>;
  }

  return (
    <div className="container text-center py-5">
      <h1 className="mb-4">Hauptseite</h1>
      <p className="mb-4">Klicke auf die Schaltfläche, um zur zweiten Seite zu gelangen.</p>

      <button className="btn btn-primary mb-2" onClick={() => navigate("/spiel")}>
        Zur zweiten Seite
      </button>
      <br />
      <button className="btn btn-primary mb-2" onClick={() => navigate("/dashboard")}>
        Dashboard
      </button>
      <br />

      {loggedIn ? (
        <>
          <button className="btn btn-danger" onClick={async () => {
            const res = await fetch(`${API_BASE_URL}/users/logout`, {
              method: 'POST',
              credentials: "include",
            });
            if (res.ok) {
              setLoggedIn(false);
              setMessage('Du hast dich ausgeloggt.'); // Set message on logout
            }
          }}>
            Ausloggen
          </button>
          {message && <p className="mt-2 text-info">{message}</p>}
        </>
      ) : (
        <>
          <button className="btn btn-success" onClick={() => navigate("/login")}>
            Einloggen
          </button>
          {message && <p className="mt-2 text-warning">{message}</p>}
        </>
      )}
       <p>test</p>
    </div>
  );
};

export default MainPage;